import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmployeeSalary } from '@/components/employee/salary';

const salaryDetailSearchSchema = z.object({
  startDate: z.string().optional(), // YYYY-MM-DD
  endDate: z.string().optional(), // YYYY-MM-DD
});

export const Route = createFileRoute('/(app)/company/salary/$employeeId')({
  component: SalaryDetailRoute,
  validateSearch: salaryDetailSearchSchema,
});

function SalaryDetailRoute() {
  const { employeeId } = Route.useParams();
  const employeeIdNum = Number(employeeId);
  
  return (
    <EmployeeSalary 
      employeeId={employeeIdNum}
      showBackButton
      backPath="/company/salary"
    />
  );
}
